import { AxiosResponse } from "axios";
import API from "../api";
import { Room } from "../models/room";
import { RoomJob } from "../models/sales";

const RoomService = {
  async getAllRoomJob(options?: any): Promise<AxiosResponse<RoomJob[]>> {
    return await API.get(`/rooms?sortBy=["name"]`, { params: options });
  },
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/rooms/count`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Room[]>> {
    return await API.get(`/rooms`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<Room>> {
    return await API.get(`/rooms/${id}`, { params: options });
  },
  async create(room: Room): Promise<AxiosResponse<Room>> {
    return await API.post("/rooms", room);
  },
  async update(id: number, room: Room): Promise<AxiosResponse<boolean>> {
    return await API.put(`/rooms/${id}`, room);
  },
};

export default RoomService;
